import React from 'react';

import ScrollToTop from './ScrollToTop';
import Steps from './Steps';
import Art from './Art';
// import WhereAmI from './WhereAmI';

const Layout = ({ children, stepsLength = 3 }) => (
  <>
    {/* <WhereAmI /> */}

    <ScrollToTop />

    <Steps total={stepsLength} />

    <Art />

    <div className="container">
      {children}

      <style jsx>{`
        div {
          flex: 1;
        }

        :global(#itau-prestamos-form) {
          min-height: 100vh;
        }
      `}</style>
    </div>
  </>
);

export default Layout;
